import {StackItem} from '../interfaces/router/stackItem';
import lightTheme from '../theme/lightTheme';
import {createNativeStackNavigator} from '@react-navigation/native-stack';

const Stack = createNativeStackNavigator();

/**
 * Create the stack navigator from the provided list of stack items and modal stack items.
 *
 * @param {StackItem[]} stacksList - The list of stack items representing the main screens.
 * @param {StackItem[]} modalsList - The list of stack items representing modal screens.
 * @returns {React.ReactElement} The JSX element representing the stack navigator.
 */
export const getStacksGroups = (
  stacksList: StackItem[],
  modalsList: StackItem[] = [],
): React.ReactElement => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerTintColor: lightTheme.text.light,
        headerShown: false,
        headerTransparent: true,
        headerBlurEffect: 'regular',
        animation: 'default',
        freezeOnBlur: true,
        // navigationBarTranslucent: true,
        // navigationBarHidden: true,
      }}
      initialRouteName={stacksList[0].name}>
      {stacksList.map((screen, idx) => (
        <Stack.Screen
          key={`screen${idx}`}
          name={screen.name}
          options={{
            headerBackTitle: 'Back',
            gestureEnabled: true,
            orientation: 'portrait',
            ...screen.options,
          }}
          component={screen.component}
        />
      ))}
      {modalsList.map((screen, idx) => (
        <Stack.Screen
          key={`screen${idx}`}
          options={{
            presentation: 'fullScreenModal',
            orientation: 'portrait',
            ...screen.options,
          }}
          name={screen.name}
          component={screen.component}
        />
      ))}
    </Stack.Navigator>
  );
};
